const LedgerReportsActionTypes = {
	/** ***************** GET LEDGER REPORTS START *********************** */
	GET_LEDGER_REPORTS_LIST_START: 'get_ledger_reports_start',
	GET_LEDGER_REPORTS_LIST_SUCCESS: 'get_ledger_reports_success',
	GET_LEDGER_REPORTS_LIST_FAILURE: 'get_ledger_reports_failure',
	GET_LEDGER_REPORTS_LIST_RESPONSE_RESET: 'get_ledger_reports_response_reset',
	GET_LEDGER_REPORTS_LIST_RESPONSE_CHANGED: 'get_ledger_reports_response_changed',
	/** ***************** GET LEDGER REPORTS END *********************** */

	/** ***************** GET ACCOUNT HEAD START *********************** */
	GET_ACCOUNT_HEAD_START: 'get_account_head_start',
	GET_ACCOUNT_HEAD_SUCCESS: 'get_account_head_success',
	GET_ACCOUNT_HEAD_FAILURE: 'get_account_head_failure',
	GET_ACCOUNT_HEAD_RESPONSE_RESET: 'get_account_head_response_reset',
	GET_ACCOUNT_HEAD_RESPONSE_CHANGED: 'get_account_head_response_changed',
	/** ***************** GET ACCOUNT HEAD END *********************** */
};
export default LedgerReportsActionTypes;
